import React from 'react';

const STATUS_CONFIG = {
  sent: { label: 'Enviado', bg: '#f0faf3', color: '#1a5c2e', border: '#cfe3d6' },
  queued: { label: 'En cola', bg: '#e8f4fd', color: '#1565c0', border: '#90caf9' },
  rejected: { label: 'Rechazado', bg: '#fdecea', color: '#c62828', border: '#ef9a9a' },
  error: { label: 'Error', bg: '#fff3cd', color: '#856404', border: '#ffd166' },
  pending: { label: 'Pendiente', bg: '#f5f5f5', color: '#666', border: '#e0e0e0' },
};

const DEFAULT_CONFIG = { label: '-', bg: '#f5f5f5', color: '#666', border: '#e0e0e0' };

/**
 * Badge visual del estado de un email (enviado, en cola, error, etc.).
 * Componente presentacional puro.
 */
export function EmailStatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || { ...DEFAULT_CONFIG, label: status || '-' };

  return (
    <span
      data-testid="email-status-badge"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '4px',
        background: config.bg, color: config.color,
        border: `1px solid ${config.border}`,
        borderRadius: '20px', padding: '3px 10px', fontSize: '12px', fontWeight: 500
      }}
    >
      {config.label}
    </span>
  );
}

export default EmailStatusBadge;
